export default "__VITE_ASSET__BCTdRjJt__"